import type { ReactNode } from "react";
import { AlertTriangle, Info, OctagonAlert } from "lucide-react";

export function Banner({ tone = "info", children, action }: { tone?: "info" | "warning" | "critical"; children: ReactNode; action?: ReactNode }) {
  const Icon = tone === "critical" ? OctagonAlert : tone === "warning" ? AlertTriangle : Info;
  return (
    <div className="banner" data-tone={tone} role={tone === "critical" ? "alert" : "region"} aria-label={tone === "info" ? "Notice" : "Warning"}>
      <Icon size={18} aria-hidden />
      <div className="banner-body">{children}</div>
      {action}
    </div>
  );
}
